/* Minimal progressive enhancement. No framework, no build step. */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var burger = e.target.closest('[data-burger]');
    if (burger) {
      var menu = document.getElementById('mobile-menu');
      if (menu) {
        var open = menu.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }

    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var input = step.parentElement.querySelector('input');
      if (!input) return;
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var next = (parseInt(input.value, 10) || min) + parseInt(step.getAttribute('data-qty-step'), 10);
      input.value = next < min ? min : next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      var main = document.getElementById('pdp-main-image');
      if (main) {
        main.src = thumb.getAttribute('data-thumb');
        main.srcset = '';
        main.alt = thumb.getAttribute('data-alt') || main.alt;
      }
      document.querySelectorAll('[data-thumb]').forEach(function (b) {
        b.setAttribute('aria-current', b === thumb ? 'true' : 'false');
      });
    }
  });

  /* Cart line quantity + sort dropdowns submit their form on change. */
  document.addEventListener('change', function (e) {
    var el = e.target.closest('[data-auto-submit]');
    if (el && el.form) el.form.submit();
  });
})();

/* Format tabs on the landing page */
document.addEventListener('click', function (e) {
  var t = e.target.closest('[data-tab]');
  if (!t) return;
  var group = t.closest('[data-tab-group]');
  if (!group) return;
  var id = t.getAttribute('data-tab');
  group.querySelectorAll('[data-tab]').forEach(function (b) {
    b.setAttribute('aria-current', b === t ? 'true' : 'false');
  });
  group.querySelectorAll('[data-panel]').forEach(function (p) {
    p.hidden = p.getAttribute('data-panel') !== id;
  });
});

/* ==========================================================================
   Motion
   Ported from the React implementation: scroll reveal, hero demo timeline,
   blink dot. No dependencies, no build step.
   ========================================================================== */
(function () {
  'use strict';

  var QUERY = '(prefers-reduced-motion: reduce)';
  var reduced = window.matchMedia && window.matchMedia(QUERY).matches;

  /* --- 1. Scroll reveal -------------------------------------------------- */

  function initReveal() {
    var nodes = document.querySelectorAll('.reveal');
    if (!nodes.length) return;

    // No observer support, or motion suppressed: show everything immediately.
    if (reduced || !('IntersectionObserver' in window)) {
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].setAttribute('data-visible', 'true');
      }
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.setAttribute('data-visible', 'true');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });

    for (var j = 0; j < nodes.length; j++) {
      // Stagger via data-delay so authors set it in Liquid, not CSS.
      var delay = nodes[j].getAttribute('data-delay');
      if (delay) nodes[j].style.transitionDelay = delay + 'ms';
      observer.observe(nodes[j]);
    }
  }

  /* --- 2. Hero demo timeline --------------------------------------------- */

  var TIMELINE = {
    read: 500,
    match: 1300,
    rowStart: 1400,
    rowStep: 200,
    flipStart: 2600,
    flipStep: 240,
    done: 3900,
    loopPause: 5200
  };

  function initDemo() {
    var demo = document.querySelector('[data-demo]');
    if (!demo) return;

    var rows = demo.querySelectorAll('[data-row]');
    var flips = demo.querySelectorAll('[data-flip]');
    var stage = demo.querySelector('[data-stage]');
    var total = rows.length;
    if (!total) return;

    // Reduced motion: CSS already pins the finished state. Just set the text.
    if (reduced) {
      if (stage) stage.textContent = stage.getAttribute('data-stage-3') || '';
      return;
    }

    demo.setAttribute('data-demo', 'playing');

    var timers = [];

    function at(delay, fn) {
      timers.push(window.setTimeout(fn, delay));
    }

    function setStage(n) {
      if (!stage) return;
      var text = stage.getAttribute('data-stage-' + n);
      if (text) stage.textContent = text;
    }

    function reset() {
      for (var i = 0; i < total; i++) rows[i].setAttribute('data-revealed', 'false');
      for (var j = 0; j < flips.length; j++) flips[j].setAttribute('data-flipped', 'false');
      setStage(0);
    }

    function play() {
      timers = [];
      reset();

      at(TIMELINE.read, function () { setStage(1); });
      at(TIMELINE.match, function () { setStage(2); });

      for (var i = 0; i < total; i++) {
        (function (index) {
          at(TIMELINE.rowStart + index * TIMELINE.rowStep, function () {
            rows[index].setAttribute('data-revealed', 'true');
          });
        })(i);
      }

      for (var k = 0; k < flips.length; k++) {
        (function (index) {
          at(TIMELINE.flipStart + index * TIMELINE.flipStep, function () {
            flips[index].setAttribute('data-flipped', 'true');
          });
        })(k);
      }

      at(TIMELINE.done, function () { setStage(3); });
      at(TIMELINE.done + TIMELINE.loopPause, play);
    }

    function stop() {
      for (var i = 0; i < timers.length; i++) window.clearTimeout(timers[i]);
      timers = [];
    }

    // Don't burn timers while the tab is hidden or the hero is scrolled past.
    if ('IntersectionObserver' in window) {
      var running = false;
      new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        if (visible && !running) { running = true; play(); }
        else if (!visible && running) { running = false; stop(); }
      }, { threshold: 0.15 }).observe(demo);
    } else {
      play();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
    });
  }

  function boot() {
    document.documentElement.classList.remove('no-js');
    initReveal();
    initDemo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ==========================================================================
   Stepped enquiry form
   Progressive enhancement: with no JS every step is visible and the form
   still submits in one go.
   ========================================================================== */
(function () {
  'use strict';

  function initEnquiry() {
    var form = document.getElementById('enquiry-form');
    if (!form) return;

    var steps = form.querySelectorAll('[data-step]');
    if (steps.length < 2) return;

    var fill = form.querySelector('[data-fill]');
    var counter = form.querySelector('[data-counter]');
    var back = form.querySelector('[data-back]');
    var next = form.querySelector('[data-next]');
    var submit = form.querySelector('[data-submit]');
    var total = steps.length;
    var current = 1;

    function show(n) {
      current = n;
      for (var i = 0; i < steps.length; i++) {
        steps[i].hidden = Number(steps[i].getAttribute('data-step')) !== n;
      }
      if (fill) fill.style.width = (n / total * 100) + '%';
      if (counter) counter.textContent = 'Step ' + n + ' / ' + total;
      if (back) back.hidden = n === 1;
      if (next) next.hidden = n === total;
      if (submit) submit.hidden = n !== total;

      var focusable = steps[n - 1].querySelector('input, textarea, select');
      if (focusable && n !== 1) focusable.focus({ preventScroll: true });
    }

    function flag(el, bad) {
      el.style.borderColor = bad ? 'var(--error)' : '';
      if (bad && !el.dataset.clearBound) {
        el.dataset.clearBound = '1';
        el.addEventListener('input', function () { el.style.borderColor = ''; }, { once: true });
      }
    }

    function valid(n) {
      var step = steps[n - 1];
      var ok = true;
      var first = null;

      var fields = step.querySelectorAll('[data-required]');
      for (var i = 0; i < fields.length; i++) {
        var bad = !fields[i].value.trim() ||
          (fields[i].type === 'email' && fields[i].value.indexOf('@') < 1);
        flag(fields[i], bad);
        if (bad) { ok = false; first = first || fields[i]; }
      }

      var groups = {};
      var radios = step.querySelectorAll('[data-required-group]');
      for (var j = 0; j < radios.length; j++) {
        var key = radios[j].getAttribute('data-required-group');
        groups[key] = groups[key] || false;
        if (radios[j].checked) groups[key] = true;
      }
      for (var key2 in groups) {
        if (!groups[key2]) {
          ok = false;
          var group = step.querySelector('[data-required-group="' + key2 + '"]');
          if (group) {
            var box = group.closest('.field');
            if (box) box.setAttribute('data-invalid', 'true');
            first = first || group;
          }
        } else {
          var g2 = step.querySelector('[data-required-group="' + key2 + '"]');
          if (g2 && g2.closest('.field')) g2.closest('.field').removeAttribute('data-invalid');
        }
      }

      if (first && first.focus) first.focus({ preventScroll: true });
      return ok;
    }

    if (next) next.addEventListener('click', function () {
      if (!valid(current)) return;
      if (current < total) show(current + 1);
    });

    if (back) back.addEventListener('click', function () {
      if (current > 1) show(current - 1);
    });

    // Guard against the last step submitting with empty required fields.
    form.addEventListener('submit', function (e) {
      if (!valid(total)) e.preventDefault();
    });

    // Enter advances rather than submitting a half-filled form.
    form.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      if (e.target.tagName === 'TEXTAREA') return;
      if (current < total) { e.preventDefault(); if (next) next.click(); }
    });

    show(1);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEnquiry);
  } else {
    initEnquiry();
  }
})();

/* Filter sidebar: open on desktop, collapsed on small screens */
(function () {
  var d = document.querySelector('[data-filters]');
  if (!d) return;
  var mq = window.matchMedia('(max-width: 959px)');
  function sync() { if (mq.matches) d.removeAttribute('open'); else d.setAttribute('open', ''); }
  sync();
  mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync);
})();

/* Pricing: monthly / annual toggle */
(function () {
  var root = document.querySelector('[data-pricing]');
  if (!root) return;
  var buttons = root.querySelectorAll('[data-period]');
  var amounts = root.querySelectorAll('[data-monthly]');
  var notes = root.querySelectorAll('[data-annual-note]');
  function set(period) {
    buttons.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-period') === period ? 'true' : 'false'); });
    amounts.forEach(function (a) {
      a.classList.add('is-swapping');
      setTimeout(function () {
        a.textContent = a.getAttribute(period === 'annual' ? 'data-annual' : 'data-monthly');
        a.classList.remove('is-swapping');
      }, 150);
    });
    notes.forEach(function (n) { n.hidden = period !== 'annual'; });
  }
  buttons.forEach(function (b) { b.addEventListener('click', function () { set(b.getAttribute('data-period')); }); });
})();

/* Quote form prefill: from a product page or from the cart */
(function () {
  var ta = document.querySelector('[data-prefill-products]');
  if (!ta) return;
  var p = new URLSearchParams(window.location.search);

  if (p.get('cart') === '1') {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;
        ta.value = cart.items.map(function (i) {
          return i.quantity + ' x ' + (i.sku || i.product_title);
        }).join('\n');
      })
      .catch(function () {});
    return;
  }

  var sku = p.get('sku'), title = p.get('product');
  if (sku || title) {
    var qty = p.get('qty') || '';
    ta.value = (qty ? qty + ' x ' : '') + (sku || '') + (title ? (sku ? ' (' + title + ')' : title) : '');
    ta.focus();
    ta.setSelectionRange(0, 0);
  }
})();
